// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__B7o-P","button":"mimic___styles_button__YLOXG"};